import { JIRA_PORTAL } from '@/constants/jira';

export function goToJiraMakeRequestLink() {
  window.open(JIRA_PORTAL, '_blanck');
}

export function goToJiraRequest(reference: string) {
  window.open(`${JIRA_PORTAL}/${reference}`, '_blanck');
}
